<section>
  <h2 class="mb-3" tabindex="0" nessAutoFocus>Person details</h2>
  <ng-container *removeIfUnauthorized="canEditPerson">
    <a *ngIf="showEditButton" class="btn btn-active mb-2 me-2" (click)="editPerson()">Edit person</a>
  </ng-container>
  <ng-container *removeIfNoPermission="canDeletePerson">
    <button type="button" *ngIf="showDeleteButton" class="btn btn-active mb-2" (click)="deletePerson()">Delete person</button>
  </ng-container>
  <div class="card">
    <div class="card-body">
      <p-messages key="personDetailMsg" [closable]="true"></p-messages>
      <div class="row gy-2 gx-3 align-items-center m-2">
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Last Updated:</div>
        <div class="col-lg-9 col-md-8">
          <ng-container *ngIf="personDTO.ModifiedOn; else createdDate">{{ personDTO.ModifiedOn | date:'MM/dd/yyyy' }} at {{ personDTO.ModifiedOn | date:'HH:mm' }} {{ userTimeZone }} by {{ personDTO.ModifiedBy }} </ng-container>
          <ng-template #createdDate>{{ personDTO.CreatedOn | date:'MM/dd/yyyy' }} at {{ personDTO.CreatedOn | date:'HH:mm' }} {{ userTimeZone }} by {{ personDTO.CreatedBy }}</ng-template>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Full name:</div>
        <div class="col-lg-9 col-md-8">{{ personDTO?.FirstName }} {{ personDTO?.MiddleName }} {{ personDTO?.LastName }} {{ personDTO?.Suffix }} <span class="badge text-bg-danger mx-2" *ngIf="isJuvenile">Juvenile</span></div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Alias:</div>
        <div class="col-lg-9 col-md-8">{{ personDTO?.Alias }}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Nickname:</div>
        <div class="col-lg-9 col-md-8">{{ personDTO?.NickName }}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Sex:</div>
        <div class="col-lg-9 col-md-8">{{ personDTO?.GenderName }}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Race:</div>
        <div class="col-lg-9 col-md-8"> {{ personDTO?.RaceName }}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Gang affiliation:</div>
        <div class="col-lg-9 col-md-8">{{ personDTO?.GangName }}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Date of birth:</div>
        <div class="col-lg-9 col-md-8">{{ personDTO?.DateOfBirth | date:"MM/dd/yyyy" }}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Social security number:</div>
        <div class="col-lg-9 col-md-8">{{ personDTO?.SSN | ssnFormat }}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Email address:</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">Email address</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personDTO?.ENESS_XREF_PeopleEmailAccounts.length == 0"><td>No email address found.</td></tr>
              <tr *ngFor="let email of personDTO?.ENESS_XREF_PeopleEmailAccounts">
                <td>{{ email.EmailAccount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Description:</div>
        <div class="col-lg-9 col-md-8">{{ personDTO?.PersonDescription | sanitizeHtml }}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Is known felon?</div>
        <div class="col-lg-9 col-md-8">{{ personDTO?.IsKnownFelon | booleanTransform }}</div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">FBI file numbers:</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">File number</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personDTO?.ENESS_XREF_PeopleFBIFileNumbers.length == 0"><td>No FBI file numbers found.</td></tr>
              <tr *ngFor="let fbiNum of personDTO?.ENESS_XREF_PeopleFBIFileNumbers">
                <td>{{ fbiNum.FBIFileNumber }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">State ID numbers:</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">State</th>
                <th scope="col">ID number</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personDTO?.ENESS_XREF_PeopleStateIDNumbers.length == 0"><td colspan="2">No state ID numbers found.</td></tr>
              <tr *ngFor="let sid of personDTO?.ENESS_XREF_PeopleStateIDNumbers">
                <td>{{ sid.StateName }}</td>
                <td>{{ sid.StateIDNumbers }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">City ID numbers:</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">State</th>
                <th scope="col">City</th>
                <th scope="col">ID number</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personDTO?.ENESS_XREF_PeopleCityIDNumbers.length == 0"><td colspan="3">No city ID numbers found.</td></tr>
              <tr *ngFor="let cid of personDTO?.ENESS_XREF_PeopleCityIDNumbers">
                <td>{{ cid.StateName }}</td>
                <td>{{ cid.CityName }}</td>
                <td>{{ cid.CityIDNumber }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Social media:</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">Social media</th>
                <th scope="col">Account name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personDTO?.ENESS_XREF_PeopleSocialMedia.length == 0"><td colspan="2">No social media found.</td></tr>
              <tr *ngFor="let smid of personDTO?.ENESS_XREF_PeopleSocialMedia">
                <td>{{ smid.SocialMediaTypeName }}</td>
                <td>{{ smid.SocialMediaHandle }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Driver's licenses:</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">State</th>
                <th scope="col">License number</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personDTO?.ENESS_XREF_PeopleDriversLicense.length == 0"><td colspan="2">No driver's licenses found.</td></tr>
              <tr *ngFor="let dlid of personDTO?.ENESS_XREF_PeopleDriversLicense">
                <td>{{ dlid.StateName }}</td>
                <td>{{ dlid.DriversLicenseNumber }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Phone Number(s):</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">Phone number(s)</th>
                <th scope="col">Type</th>
                <th scope="col">Primary</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personDTO?.ENESS_XREF_PeoplePhoneNumbers?.length == 0"><td colspan="3">No phone number found.</td></tr>
              <tr *ngFor="let phone of personDTO?.ENESS_XREF_PeoplePhoneNumbers">
                <td>{{ phone.PhoneNumber | phoneNumberFormat }}</td>
                <td class="text-break">{{ phone.PhoneNumberType }} <ng-container *ngIf="!!phone.PhoneNumberOtherType">({{ phone.PhoneNumberOtherType }})</ng-container></td>
                <td>{{ phone.IsPrimary | booleanTransform }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Address(es):</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">Street Address</th>
                <th scope="col">Unit</th>
                <th scope="col">City</th>
                <th scope="col">State</th>
                <th scope="col">Zip</th>
                <th scope="col">Person Address Type</th>
                <th scope="col">Primary</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personDTO?.ENESS_XREF_PeopleAddresses.length == 0"><td colspan="7">No address(es) found.</td></tr>
              <tr *ngFor="let aid of personDTO?.ENESS_XREF_PeopleAddresses">
                <td><button class="btn btn-link text-start px-0" aria-label="{{aid.ENESS_Address?.StreetAddress + ' details'}}" tabindex="0" (click)="viewAddressDetails(aid.AddressID, aid.AddressStagingID, aid.IsEditable, aid.ENESS_REF_AddressTypes?.AddressTypeName, aid.OtherAddressType)">{{ aid.ENESS_Address?.StreetAddress }}</button></td>
                <td>{{ aid.ENESS_Address?.Unit }}</td>
                <td>{{ aid.ENESS_Address?.CityName }}</td>
                <td>{{ aid.ENESS_Address?.StateName }}</td>
                <td>{{ aid.ENESS_Address?.PostalCode }}</td>
                <td>{{ aid.ENESS_REF_AddressTypes?.AddressTypeName }}{{ aid.AddressTypeID !== null && (aid.OtherAddressType === null || aid.OtherAddressType?.trim().length === 0) ? "" : ": " + aid.OtherAddressType }}</td>
                <td>{{ aid.IsCurrent | booleanTransform }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-3 col-md-4 text-xs-start text-md-end">Attachments:</div>
        <div class="col-lg-9 col-md-8 table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <thead>
              <tr>
                <th scope="col">Filename</th>
                <th scope="col" class="text-nowrap">Created by</th>
                <th scope="col" class="text-nowrap">Upload date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personDTO?.ENESS_XREF_PeopleAttachments.length == 0">
                <td colspan="3">No uploaded attachments found.</td>
              </tr>
              <tr *ngFor="let att of personDTO?.ENESS_XREF_PeopleAttachments">
                <th scope="row">
                  <a tabindex="0" class="download-link" title="Download attachment file" (click)="downloadPersonAttachment(att)">{{att?.FileName}}</a>
                </th>
                <td>{{att?.CreatedBy}}</td>
                <td>{{att?.CreatedOn | date:'MM/dd/yyyy'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="card-title"><h3>NESS Associations</h3></div>
      <div class="row">
        <div class="table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <caption class="caption-top form-label text-body fw-bold">LE cases</caption>
            <thead class="thead-dark">
              <tr>
                <th scope="col">Event LE case #</th>
                <th scope="col">LE agency</th>
                <th scope="col">Event crime type</th>
                <th scope="col">Person type</th>
                <th scope="col">Event date</th>
                <th scope="col">Crime Gun ID(s)</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="peopleService.personLECases$ | async as personLECases;else loadingLeCases">
                <tr *ngIf="personLECases == null || personLECases.length == 0"><td colspan="6">No LE cases found.</td></tr>
                <tr *ngFor="let lcn of personLECases">
                  <td>{{ lcn.LECaseNumber }}</td>
                  <td>{{ lcn.AgencyName }}</td>
                  <td>{{ lcn.CrimeTypeName }}</td>
                  <td>{{ lcn.PersonTypeName }}</td>
                  <td>{{ lcn.EventDate | date:"MM/dd/yyyy" }}</td>
                  <td>
                    <ng-container *ngIf="lcn.RelatedCrimeGuns">
                      <div class="text-nowrap" *ngFor="let cg of lcn.RelatedCrimeGuns.split(','); index as i">
                        <a (click)="openRelatedCrimeGun($event, cg)">{{ cg }}</a>
                      </div>
                    </ng-container>
                  </td>
                </tr>
              </ng-container>
              <ng-template #loadingLeCases>
                <tr>
                  <td colspan="5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row" *removeIfNoPermission="canViewIRs">
        <div class="table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <caption class="caption-top form-label text-body fw-bold">Information reports</caption>
            <thead class="thead-dark">
              <tr>
                <th scope="col">Information report tracking number</th>
                <th scope="col" class="created-on">Created date</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="peopleService.personInfoReports$ | async as infoReports;else loadingInfoReports">
                <tr *ngIf="infoReports == null || infoReports.length == 0"><td colspan="2">No information reports found.</td></tr>
                <tr *ngFor="let ir of infoReports">
                  <td>{{ ir.IntelligenceTrackingNumber  }}</td>
                  <td>{{ ir.CreatedOn | date:"MM/dd/yyyy" }}</td>
                </tr>
              </ng-container>
              <ng-template #loadingInfoReports>
                <tr>
                  <td colspan="2">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row" *removeIfNoPermission="canViewResults">
        <div class="table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
            <caption class="caption-top form-label text-body fw-bold">Results tracking</caption>
            <thead class="thead-dark">
              <tr>
                <th scope="col">Results tracking number</th>
                <th scope="col" class="created-on">Created date</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="peopleService.personResults$ | async as personResults;else loadingResults">
                <tr *ngIf="personResults == null || personResults.length == 0"><td colspan="2">No results tracking found.</td></tr>
                <tr *ngFor="let rslt of personResults">
                  <td>{{ rslt.InvestigativeTrackingNumber }}</td>
                  <td>{{ rslt.CreatedOn | utcToLocal:'MM/dd/yyyy' }}</td>
                </tr>
              </ng-container>
              <ng-template #loadingResults>
                <tr>
                  <td colspan="2">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div *ngIf="showDeleteHistoryForm">
      <p-dialog header="Delete comment" [(visible)]="showDeleteHistoryForm" appendTo="body" [draggable]="false" [modal]="true" [resizable]="true" styleClass="deleteDialog" [baseZIndex]="3" [style]="{width: '50vw'}" [breakpoints]="{'992px': '75vw', '576px': '90vw'}">
        <ness-delete-history-form [targetId]="deleteHistoryTargetId" [targetTable]="deleteHistoryTargetTableName" (deleteHistorySubmitted)="onDeleteHistorySubmitted($event)" (closeForm)="onCloseDeleteHistoryForm()"></ness-delete-history-form>
      </p-dialog>
    </div>
  </div>
</section>
<p-sidebar (onShow)="onShowSidebar()" (onHide)="onViewPersonAddressClose()" [(visible)]="displaySidebar" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false">
  <ng-container *ngIf="openViewPersonAddressDetails">
    <ng-container *ngIf="personAddress; else loadingAddress">
      <ness-location-detail *ngIf="showLocationView" [addressDTO]="personAddress" [hasDeletePermission]="false" [hasEditPermission]="hasPermissionToEditAddress" [personAddressType]="personAddressType" [isFromPersonDetails]="true" (editLocationLocationClicked)="editLocation($event)"></ness-location-detail>
    </ng-container>
  </ng-container>
  <button *ngIf="!openViewPersonAddressDetailForm" type="button" (click)="onClickCloseButton()" class="btn btn-active m-3">Close</button>
  <ng-container *ngIf="openViewPersonAddressDetailForm">
    <ng-container *ngIf="personAddress; else loadingAddress">
      <ness-location-form *ngIf="showEditLocationView" [titleText]="'Edit location'" [isEventLocationForm]="false" [isEditForm]="true" [locationFormData]="personAddress" (locationSaved)="onLocationFormClose($event)" (closeForm)="onLocationFormClose(personAddress)"></ness-location-form>
    </ng-container>
  </ng-container>
  <ng-template #loadingAddress>
    <p-messages #viewPersonDetailMsg key="viewAddressDetailsMsg" [closable]="true"></p-messages>
    <div class="m-3">Loading location...</div>
  </ng-template>
</p-sidebar>
